import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Container } from '../../styled/containers';
import Card from '../card';
import { List, Wrapper } from './styles';

const PersonCardList = ({ list, borderTop, columns, limit }) => {
  const [count] = useState(limit);

  if (!list) return null;

  return (
    <Wrapper $borderTop={borderTop}>
      <Container $padding={false}>
        <List columns={columns}>
          {list.slice(0, count).map((person, i) => (
            <Card
              key={person.id + i}
              person={person}
              columns={columns}
              link={person.page}
            />
          ))}
        </List>
      </Container>
    </Wrapper>
  );
};

PersonCardList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
    })
  ),
  columns: PropTypes.number,
  borderTop: PropTypes.bool,
  limit: PropTypes.number,
};

PersonCardList.defaultProps = {
  columns: 2,
};

export default PersonCardList;
